export default {
  thisVerbFoundIn: 'Este verbo se encontró en:',
  verbWithoutCognitiveLevel: 'Verbo sin nivel cognitivo.',
  alreadyHasOrderMessage: 'Este {entity} ya cuenta con {competence} en ese orden.',

  // ========== SentenceForm ==========
  insertOrCreateTooltip: 'Ingresar oración directamente o utilizar el modo de "creación"',
  insert: 'Insertar',
  action: 'Acción',
  object: 'Objeto',
  condition: 'Condición',
  verb: 'Verbo',
  content: 'Contenido',
  context: 'Contexto',
  information: 'Información',
  whatDoes: '¿Qué hace?',
  whatWillKnow: '¿Qué sabrá hacer?',
  actionToPerform: 'La acción a',
  perform: 'desempeñar',
  expressedIn: 'Se expresa en',
  indicative: 'indicativo',
  indicativeExample: '(diseña, comunica)',
  reflectsAction: 'Refleja una',
  assessableAction: 'acción factible de evaluar',
  observableAction: 'y observar en tiempo presente',
  aboutWhat: 'Sobre Qué',
  aboutWhatPerforms: 'realiza la acción (objeto)',
  whatToEvaluate: '¿Qué le pediré que evalúe, maneje, analice, informe?',
  forWhat: '¿Para Qué?',
  inWhatContext: 'En Qué Contexto',
  attitudes: 'Actitudes (Competencias Transversales)',
  whatMeans: '¿Qué medios, escenarios, situaciones, contextos normativos?',
  consideredInRelation: 'Se consideran en relación al objeto/contenido y a la acción a realizar',
  selectTaxonomy: '--Seleccione Taxomonía--',
  customizeVerb: 'Personalizar',
  noVerbsMatch: 'No hay verbos que coincidan con su búsqueda.',
  verbSavedWithoutLevel: 'Este verbo se guardará sin nivel cognitivo.',
  recommendGenericCompetence: 'Se recomienda responder a una Competencia Genérica.',
  selectVerb: 'Seleccione un verbo',
  mustSelectVerb: 'Debe seleccionar un verbo.',
  contentCannotBeEmpty: 'El contenido no puede estar vacío.',
  conditionCannotBeEmpty: 'La condición no puede estar vacía.',
  cognitiveLevel: 'Nivel Cognitivo',
}